module.exports = __webpack_public_path__ + "static/images/multiple.2yo8g9a.svg";